export default "__VITE_ASSET__B5YBfjwC__"